export default __webpack_public_path__ + "static/media/email-open-outline.6434e3bb.svg";